export const getCompanyStatus = (resolve, reject, tokenId, companyId) => {
  let req = new Request(window.CONFIG.AWS_URL + '/getcompanystatus', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      companyName: companyId
    })
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getCompanyStatus response format error.');
      }
    } else {
      reject('getCompanyStatus response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const editCompanyInfo = (resolve, reject, tokenId, reqBodyObj) => {
  let req = new Request(window.CONFIG.AWS_URL + '/editcompany', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('editCompanyInfo response format error.');
      }
    } else {
      reject('editCompanyInfo response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}